/**
 * Local 5xx detection + modal for 患者情報検索 only.
 * Pulled out of the global react-query handler so this screen owns the behavior.
 *
 * Dedupe window prevents 2 simultaneous query/mutation failures from stacking modals.
 */
import { SERVER_ERROR_MESSAGE } from '@/constants/messages';

const DEDUPE_MS = 1000;
let dispatched = false;

export function isServerError(err: unknown): boolean {
  const status = (err as { response?: { status?: number } })?.response?.status;
  return typeof status === 'number' && status >= 500 && status < 600;
}

/**
 * Call once with the `warning` fn from `useAppModal()`. Subsequent calls within
 * the dedupe window are swallowed so only one modal opens per error burst.
 */
export function showServerErrorModal(
  warning: (config: { content: string; okText: string }) => unknown,
): void {
  if (dispatched) return;
  dispatched = true;
  setTimeout(() => {
    dispatched = false;
  }, DEDUPE_MS);
  warning({ content: SERVER_ERROR_MESSAGE, okText: '閉じる' });
}
